// src/admin/components/ApiErrorBoundary.js
import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

const ApiErrorBoundary = ({ error, onRetry, children }) => {
  if (error) {
    return (
      <div className="bg-yellow-50 border border-yellow-200 rounded-md p-4 mb-6">
        <div className="flex">
          <div className="flex-shrink-0">
            <AlertTriangle className="h-5 w-5 text-yellow-400" />
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-yellow-800">
              API Endpoint Not Available
            </h3>
            <div className="mt-2 text-sm text-yellow-700">
              <p>
                The admin API endpoints are not yet configured. This is expected during development. 
                The interface is ready and will work once the backend endpoints are implemented.
              </p>
              {onRetry && (
                <div className="mt-3">
                  <button
                    onClick={onRetry}
                    className="inline-flex items-center px-3 py-2 border border-yellow-300 rounded-md text-sm font-medium text-yellow-800 bg-yellow-100 hover:bg-yellow-200"
                  >
                    <RefreshCw className="h-4 w-4 mr-2" />
                    Retry
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default ApiErrorBoundary;
